module.exports = {
  QuickEntry: '快捷入口',
  LastRefreshTime: '数据最后更新于',
  SopBoard: 'SOP看板',
  SeaExport: '海运出口',
  SeaImport: '海运进口',
  AirExport: '空运出口',
  AirImport: '空运进口',
  RailwayExport: '铁路出口',
  RailwayImport: '铁路进口',
  IntegratedJob: '综合物流',
  BusinessVolumeGraph: '业务量曲线图',
  PackUp: '收起',
  Unfold: '展开',
  SopReveal: 'SOP显示',
  SopFilterConditions: 'SOP过滤条件',
  SaveSucceed: '保存成功',
  QuickEntryPopover: {
    FirstLine: '1.您可从菜单栏中拖拽任意功能至快捷入口',
    SecondLine: '2.当快捷入口过多一行显示不下时会自动换行显示。'
  },
  SopBoardPopover: {
    FirstLine: '1.SOP面板只统计您可查看的业务，并且只展示您勾选的节点与状态。',
    SecondLine: '2.业务的节点状态变成“已完成”后就不会出现在此节点中。',
    ThirdLine: '3.光标移到节点上方会弹出此节点中您勾选的状态，以及对应的业务数量。',
    FourthLine: '4.点击节点或点击状态均可跳转至相对应的业务功能并查询出相对应的业务。'
  },
  LineChartPopover: {
    FirstLine: '1.业务量曲线图只显示最近七天与您有关的新业务数量。'
  },
  SopFilterContent: {
    SopFilterConditionsTip: '满足以下任意条件的业务才会统计在SOP看板中',
    BusinessState: '按业务状态',
    Operation: '正操作',
    Submit: '已提交',
    Audit: '已审核',
    Date: '按业务日期',
    ETD: '业务日期（ETD）不早于',
    ETA: '业务日期（ETA）不早于',
    Days: '天之前',
    PleaseInputDays: '请输入天数',
    PleaseSelectBusinessType: '请选择至少一个业务状态',
    PreCommit: '预提交'
  },
  QuickEntryLayer: {
    FirstLine: '1.点击此处可快速进入功能',
    SecondLine: '2.可从菜单中直接拖拽出快捷入口'
  },
  SopBoardLayer: {
    FirstLine: '1.此处显示您关注的SOP节点',
    SecondLine: '2.鼠标移到节点上方即可显示节点下各个状态的业务数量',
    ThirdLine: '3.显示的节点与状态均可自由配置',
    FirstLine2: '1.此处显示您关注的看板事项',
    SecondLine2: '2.点击对应的看板事项，会显示对应数据'
  },
  LineChartLayer: {
    FirstLine: '1.此处显示最近七天与您有关的新业务数量',
    SecondLine: '2.可分别根据业务日期和业务创建日期统计'
  },
  SettingLayer: {
    FirstLine: '点击齿轮按钮进入配置页可调整SOP看板展示的节点与状态',
    SecondLine: '此处展示最近一次更新数据时间'
  },
  NextStep: '下一步',
  Loading: '数据加载中...',
  hasPermission: '抱歉，您没有权限',
  warningMessage: '预警消息',
  ignoreMessage: '忽略消息',
  ignoreSelected: '忽略选中',
  restoreSelected: '还原选中',
  ScreeningContent: '筛选内容：',
  Warning: '预警',
  nodeName: '节点名称',
  nodeState: '节点状态',
  warningLevel: '预警级别',
  warningAt: '预警时间',
  warningContent: '预警内容',
  sift: '筛选',
  toDoList: '待办事项列表',
  SopWarning: 'SOP预警',
  DelTrackingDetailConfirm: '注意：将会删除所关联的业务明细和sop节点',
  DelTrackingConfirm: '是否要删除该节点？该节点删除后相关业务单据的节点也会同步删除。',
  copyTrackingTemplateConfirm: '是否复制【{0}】模板？',
  SelectTheNode: '选择节点',
  StatusType: '状态类型',
  AutomaticTriggering: '自动触发',
  ExternalEncoding: '外部编码',
  ReportTemplate: '报表模板',
  SendNotifications: '发送通知',
  NotSendNotifications: '不发送通知',
  InitialState: '初始状态'
}
